import React, { useState, useEffect,useRef } from "react";
import Moment from "moment";
import teamImage from "./constants.json";

export const useCountdown = (date) => {
    const [timerDays, setTimerDays] = useState("00");
    const [timerHours, setTimerHours] = useState("00");
    const [timerMinutes, setTimerMinutes] = useState("00");
    const [timerSeconds, setTimerSeconds] = useState("00");

    const now = new Date(Moment.utc().utcOffset(330).format('YYYY-MM-DDTHH:mm:ss')).getTime();
    const interval = useRef();
    const startTimer = () => {
        const countdownDate = new Date(Date.parse(Moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss"))).getTime();

         interval.current = setInterval(() => {
            const distance = countdownDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (distance < 0) {
                // Stop
                if(interval.current !== null)  clearInterval(interval.current);
            } else {
                // Update
                setTimerDays(days);
                setTimerHours(hours);
                setTimerMinutes(minutes);
                setTimerSeconds(seconds);
            }
        }, 1000);
    };
    useEffect(() => {
        startTimer();
        return () => {
            if(interval.current !== null) clearInterval(interval.current);
        };
    });
    return {
        days: timerDays,
        hours: timerHours,
        minutes: timerMinutes,
        seconds: timerSeconds,
    };
}